<template>
  <div>
    <div class="checkout-container w-full"></div>
  </div>
</template>

<script>
import { computed, onMounted } from "vue";
import { useStore } from "vuex";

export default {
  setup() {
    const store = useStore();
    const subscription = computed(() => store.state.subscription);

    onMounted(() => {
      const referral = window.Rewardful && window.Rewardful.referral;
      window.Paddle.Checkout.open({
        method: "inline",
        product: subscription.value.plan_id,
        passthrough: JSON.stringify({ rewardful: { referral: referral } }),
        email: "niya.bedri44@gmail.com",
        country: "",
        allowQuantity: false,
        disableLogout: true,
        frameTarget: "checkout-container", // The className of your checkout <div>
        frameInitialHeight: 416,
        frameStyle:
          "width: 100%; min-width: 280px; background-color: transparent; border: none;", // Please ensure the minimum width is kept at or above 495px
      });
    });

    const role = computed(() => store.state.role);

    return {
      subscription,
      role,
    };
  },
};
</script>

<style></style>
